import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showTooltips
    ? _c(
        "div",
        { staticClass: "review-card-tooltips d-flex align-center ga-2" },
        [
          _setup.showAssessments
            ? _c(
                VMenu,
                {
                  attrs: {
                    "z-index": "110",
                    attach: "",
                    disabled: !_setup.assessmentsTransformed.length,
                    "close-on-content-click": false,
                    "open-on-hover": !_setup.isMobile,
                    "offset-y": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "div",
                              _vm._g(
                                _vm._b(
                                  { ref: "starsRef" },
                                  "div",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "review-card-tooltips__stars d-inline-flex align-center",
                                    class: _setup.starsModifier,
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "ui-icon-rating-star-filled ui-icon-fz-smaller rating--text",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-subtitle-2 text--text ml-1",
                                      },
                                      [_vm._v(_vm._s(_setup.starsValue))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "review-card-tooltips__stars-label text-body-2 ml-2",
                                      },
                                      [_vm._v(_vm._s(_setup.starsLabel))]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1652850465
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    VCard,
                    { staticClass: "pa-5", attrs: { elevation: "0" } },
                    _vm._l(
                      _setup.assessmentsTransformed,
                      function (assessment, index) {
                        return _c(
                          "div",
                          {
                            key: assessment.name,
                            class: { "mt-4": index > 0 },
                          },
                          [
                            _c("div", { staticClass: "text-no-wrap" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(assessment.name) +
                                  "\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex" },
                              [
                                _vm._l(assessment.filledStars, function (i) {
                                  return _c(
                                    VIcon,
                                    {
                                      key: `filled-${i}`,
                                      class: { "ml-1": i > 1 },
                                      attrs: { color: "rating", small: "" },
                                    },
                                    [
                                      _vm._v(
                                        "\n            ui-icon-rating-star-filled\n          "
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(assessment.outlineStars, function (i) {
                                  return _c(
                                    VIcon,
                                    {
                                      key: `outline-${i}`,
                                      staticClass: "ml-1",
                                      attrs: { color: "rating", small: "" },
                                    },
                                    [
                                      _vm._v(
                                        "\n            ui-icon-rating-star-outline\n          "
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-capitalize ml-2",
                                    class: assessment.color,
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(assessment.status) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.showStatuses
            ? _c(
                VMenu,
                {
                  attrs: {
                    "z-index": "110",
                    attach: "",
                    "nudge-left": _setup.isMobile
                      ? _setup.statusesTooltipOffset
                      : undefined,
                    "close-on-content-click": false,
                    "open-on-hover": !_setup.isMobile,
                    "offset-y": "",
                  },
                  on: { input: _setup.onStatusesTooltipToggle },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "div",
                              _vm._g(
                                _vm._b(
                                  { on: { mouseenter: _setup.updateOffset } },
                                  "div",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "review-card-tooltips__verification d-inline-flex align-center",
                                    attrs: {
                                      "aria-label":
                                        _setup.tStatic("Отзыв проверен"),
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "ui-icon-shield-check ui-icon-fz-big",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-body-2 ml-1" },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _setup.verificationStatuses.length
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4125234337
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    VCard,
                    {
                      staticClass: "text--text",
                      attrs: { width: "304", elevation: "0" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "pa-4" },
                        [
                          _c("div", { staticClass: "text-subtitle-1" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.tStatic("Отзыв проверен")) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _setup.verificationStatuses,
                            function (status) {
                              return _c(
                                "div",
                                { key: status, staticClass: "d-flex mt-2" },
                                [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        status /* eslint-disable-line vue/no-v-html */
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(VSpacer),
                                  _vm._v(" "),
                                  _c(
                                    VIcon,
                                    { attrs: { color: "text-success" } },
                                    [
                                      _vm._v(
                                        "\n            ui-icon-check\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(VDivider),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center text-caption text-secondary--text pa-4",
                        },
                        [
                          _c(VIcon, { attrs: { dense: "" } }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.originInfo.icon) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-3" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.tStatic("Оставлен через")) +
                                " " +
                                _vm._s(_setup.originInfo.text) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }